import React from 'react'
import { Link } from 'react-router-dom'

function Home() {
    return (
        <>
            <div className="hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="hero-content">
                                <div className="section-title dark-section">
                                    <h3 className="wow fadeInUp">
                                        welcome to FidelanchoR Services
                                    </h3>
                                    <h1
                                        className="text-anime-style-2"
                                        data-cursor="-opaque"
                                    >
                                        <span>Empowering</span> your financial
                                        success journey
                                    </h1>
                                    <p
                                        className="wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        Guiding you with expert insights and
                                        strategic solutions to achieve financial
                                        growth, stability, and long-term
                                        success, Through our Co-operative
                                        platform, Micro-lending and Tax
                                        consulting services
                                    </p>
                                </div>
                                <div
                                    className="hero-content-body wow fadeInUp"
                                    data-wow-delay="0.4s"
                                >
                                    <div className="hero-btn">
                                        <Link
                                            to="/contact"
                                            className="btn-default"
                                        >
                                            get started
                                        </Link>
                                    </div>
                                    <div className="hero-introduction-video">
                                        <div className="video-play-button">
                                            <a
                                                href="https://www.youtube.com/watch?v=Y-x0efG1seA"
                                                className="popup-video"
                                                data-cursor-text="Play"
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/icon-play.svg`}
                                                    alt=""
                                                />
                                            </a>
                                            <p>introduction</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image">
                                <div className="hero-img">
                                    <figure>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/hero-img.png`}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="company-experience">
                                    <h3>
                                        <span className="counter">21</span>+
                                    </h3>
                                    <p>Years of experience in finance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Us Section */}
            <div className="about-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-us-images">
                                <div className="about-img-1">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/about-img-1.jpg`}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="about-img-2">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/about-img-2.jpg`}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="contact-circle">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/contact-us-img.svg`}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-us-content">
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">about us</h3>
                                    <h2
                                        className="text-anime-style-2"
                                        data-cursor="-opaque"
                                    >
                                        Trusted guidance for{' '}
                                        <span>financial growth</span>
                                    </h2>
                                    <p
                                        className="wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        With years of expertise in technology,
                                        finance and consulting, we provide
                                        tailored strategies to help you achieve
                                        sustainable growth. Our commitment is to
                                        guide you, provide you platforms you can
                                        leverage for financial growth , provide
                                        you insight, and a personalized
                                        approach.
                                    </p>
                                </div>
                                <div className="about-content-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="about-content-info">
                                                <div
                                                    className="about-goal-box wow fadeInUp"
                                                    data-wow-delay="0.4s"
                                                >
                                                    <div className="icon-box">
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/images/icon-financial-strategies.svg`}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="about-goal-box-content">
                                                        <h3>
                                                            financial strategies
                                                        </h3>
                                                        <p>
                                                            Tailored services to
                                                            meet your unique
                                                            financial needs and
                                                            goals.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="about-contact-box wow fadeInUp"
                                                    data-wow-delay="0.6s"
                                                >
                                                    <div className="icon-box">
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/images/icon-phone.svg`}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="about-contact-content">
                                                        <p>
                                                            <a href="tel:+234 705 803 0389">
                                                                +234 705 803
                                                                0389
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div
                                                className="about-author-box wow fadeInUp"
                                                data-wow-delay="0.4s"
                                            >
                                                <div className="about-info-list">
                                                    <ul>
                                                        <li>
                                                            Co-operative
                                                            Platform
                                                        </li>
                                                        <li>
                                                            Micro-lending
                                                            Services
                                                        </li>
                                                        <li>Tax Consulting</li>
                                                        <li>
                                                            Financial Reporting
                                                            &amp; analysis
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Our Services Section */}
            <div className="our-services">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="our-service-content">
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">services</h3>
                                    <h2
                                        className="text-anime-style-2"
                                        data-cursor="-opaque"
                                    >
                                        Expert finance &amp; consult services{' '}
                                        <span>for success</span>
                                    </h2>
                                </div>
                                <div
                                    className="service-content-btn wow fadeInUp"
                                    data-wow-delay="0.25s"
                                >
                                    <Link
                                        to="/services"
                                        className="btn-default"
                                    >
                                        all services
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="our-service-list">
                                {[
                                    {
                                        num: '01',
                                        icon: 'icon-service-1.svg',
                                        title: 'Online Co-operative Platform',
                                        desc: 'Join our digital co-operative for collective financial growth through savings, investments, and affordable loans.',
                                        link: '/service-cooperative',
                                    },
                                    {
                                        num: '02',
                                        icon: 'icon-service-2.svg',
                                        title: 'Micro-Lending Services',
                                        desc: 'Accessible financing solutions for individuals and small businesses to bridge financial gaps.',
                                        link: '/service-micro-lending',
                                    },
                                    {
                                        num: '03',
                                        icon: 'icon-service-3.svg',
                                        title: 'Tax Consulting Services',
                                        desc: 'Comprehensive tax advisory and compliance services to minimize liabilities and ensure regulation adherence.',
                                        link: '/service-tax-consulting',
                                    },
                                    {
                                        num: '04',
                                        icon: 'icon-service-4.svg',
                                        title: 'Financial Reporting & Analysis',
                                        desc: 'Transform financial data into actionable insights for informed business decisions and growth opportunities.',
                                        link: '/service-financial-reporting',
                                    },
                                ].map((service, idx) => (
                                    <div className="service-item" key={idx}>
                                        <div className="service-no">
                                            <h2>{service.num}</h2>
                                        </div>
                                        <div className="service-content-box">
                                            <div className="icon-box">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/${service.icon}`}
                                                    alt=""
                                                />
                                            </div>
                                            <div className="service-item-content">
                                                <h3>{service.title}</h3>
                                                <p>{service.desc}</p>
                                                <Link
                                                    to={service.link}
                                                    className="service-btn"
                                                >
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/images/arrow-white.svg`}
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Our Feature Section */}
            <div className="our-feature">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-title dark-section">
                                <h3 className="wow fadeInUp">our feature</h3>
                                <h2
                                    className="text-anime-style-2"
                                    data-cursor="-opaque"
                                >
                                    Key features of our finance{' '}
                                    <span>and consulting</span>
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="section-btn wow fadeInUp"
                                data-wow-delay="0.2s"
                            >
                                <Link to="/contact" className="btn-default">
                                    contact now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="our-feature-list">
                                {[
                                    {
                                        icon: 'icon-our-feature-1.svg',
                                        title: 'Local Expertise, Global Standards',
                                        desc: "Our team of certified professionals combines deep knowledge of Nigeria's financial landscape with international best practices.",
                                    },
                                    {
                                        icon: 'icon-our-feature-2.svg',
                                        title: 'Commitment to Inclusion',
                                        desc: "We prioritize underserved communities, supporting Nigeria's financial inclusion goals with accessible services for all.",
                                    },
                                    {
                                        icon: 'icon-our-feature-3.svg',
                                        title: 'Technology-Driven',
                                        desc: '24/7 access through our user-friendly app and website, secured with bank-grade encryption and data protection compliance.',
                                    },
                                    {
                                        icon: 'icon-our-feature-4.svg',
                                        title: 'Transparency and Trust',
                                        desc: 'Adherence to strict regulatory standards  and compliance with clear communication.',
                                    },
                                    {
                                        icon: 'icon-our-feature-5.svg',
                                        title: 'Community Impact',
                                        desc: "Supporting local projects and empowering members to contribute to Nigeria's economic growth and cooperative revitalization.",
                                    },
                                ].map((feature, idx) => (
                                    <div
                                        className="our-feature-item wow fadeInUp"
                                        data-wow-delay={`${idx * 0.2}s`}
                                        key={idx}
                                    >
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/${feature.icon}`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="feature-item-content">
                                            <h3>{feature.title}</h3>
                                            <p>{feature.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* How It Works Section */}
            <div className="how-it-work">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="how-it-work-content">
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">
                                        how it work
                                    </h3>
                                    <h2
                                        className="text-anime-style-2"
                                        data-cursor="-opaque"
                                    >
                                        Our process for financial{' '}
                                        <span>success</span>
                                    </h2>
                                    <p
                                        className="wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        Our process is designed to guide you
                                        every step of the way. From initial
                                        consultation to personalized strategy
                                        development.
                                    </p>
                                </div>
                                <div
                                    className="how-it-work-btn wow fadeInUp"
                                    data-wow-delay="0.4s"
                                >
                                    <Link to="/contact" className="btn-default">
                                        learn more
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="work-steps-box">
                                {[
                                    {
                                        num: '01',
                                        title: 'Initial Consultation',
                                        desc: 'We begin with a personalized consultation to understand your financial goals, challenges, and specific needs within the Nigerian context.',
                                    },
                                    {
                                        num: '02',
                                        title: 'Customized Solution',
                                        desc: 'Our experts develop a tailored financial strategy that aligns with your objectives and complies with Nigerian regulations.',
                                    },
                                    {
                                        num: '03',
                                        title: 'Implementation & Support',
                                        desc: 'We guide you through implementation and provide ongoing support to ensure your financial success in the Nigerian market.',
                                    },
                                ].map((step, idx) => (
                                    <div
                                        className="work-step-item wow fadeInUp"
                                        data-wow-delay={`${idx * 0.2}s`}
                                        key={idx}
                                    >
                                        <div className="work-step-item-content">
                                            <h3>step</h3>
                                            <h2>{step.title}</h2>
                                            <p>{step.desc}</p>
                                        </div>
                                        <div className="work-step-item-no">
                                            <h2>{step.num}</h2>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home
